// Tryb — season re-up.
//
// Everything carries over from season 1. Only the dates change, and last
// season's members get first refusal before the waitlist hears about it.

import { Button } from "../../ds/index.js";
import { Card, InkCard, Overline, SectionTitle } from "../../components/Card.jsx";
import { FieldCell } from "../../components/TrybField.jsx";
import { useStudio } from "../../lib/studioContext.js";
import { useFieldViews } from "../../lib/useFieldViews.js";
import { api } from "../../lib/api.js";

const REUP_FIELDS = ["D1.01", "D1.04", "D1.03", "D1.02", "D1.07", "D1.08"];

export default function SeasonReup({ onNavigate, onEditListing }) {
  const { vals, showToast, applyStudio, withFlush } = useStudio();
  const { fieldViews } = useFieldViews();

  const summary = [
    ["Tryb", vals["B1.01"]],
    ["When", `${vals["B2.01"]} · ${vals["B2.04"]}s ${vals["B2.05"]} · ${vals["B2.02"]} nights × ${vals["B2.03"]} min`],
    ["Where", `${vals["C1.03"]} · ${vals["C1.05"]}`],
    ["The After", vals["B3.01"] ? `${vals["B3.02"]} · ${vals["B3.05"]} min · ${vals["B3.07"]}` : "Not included"],
    ["Seats", `${vals["B4.01"]} max · runs at ${vals["B4.02"]} · ${vals["B4.06"]}`],
    ["Price", `₹${vals["E.01"]} a season · trial ₹${vals["E.02"] || "—"}`],
    ["Policies", `${vals["E.07"]} · ${vals["E.08"]}`],
    ["Safety", `${vals["F.01"] === "None" ? "Alcohol-free" : vals["F.01"]} · ${vals["F.03"]}`],
  ];

  const publish = () =>
    withFlush(async () => {
      try {
        applyStudio(await api.publishReup());
        onNavigate("trybs");
        showToast("Season 2 is open to your members", "They’ve got three days. Then the waitlist hears.");
      } catch (e) {
        showToast(e.message, e.hint);
      }
    });

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1.1fr", gap: 20, alignItems: "start" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <Card padding={28}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <SectionTitle>Carried over from season 1</SectionTitle>
            <Button size="sm" variant="ghost" onClick={onEditListing}>
              Edit tryb
            </Button>
          </div>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--text-muted)", marginBottom: 18 }}>
            We remembered all of this. Only touch it if something’s actually different.
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {summary.map(([k, v]) => (
              <div
                key={k}
                style={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 16,
                  padding: "10px 0",
                  borderTop: "1px solid var(--border-subtle)",
                  fontSize: "var(--text-sm)",
                }}
              >
                <span style={{ color: "var(--text-muted)" }}>{k}</span>
                <span style={{ color: "var(--text-primary)", fontWeight: 600, lineHeight: 1.45 }}>{v}</span>
              </div>
            ))}
          </div>
        </Card>

        <InkCard>
          <div style={{ fontFamily: "var(--font-display)", fontSize: "var(--text-lg)", fontWeight: 800, marginBottom: 6, letterSpacing: "var(--tracking-snug)" }}>
            Season 1 members go first.
          </div>
          <div style={{ fontSize: "var(--text-sm)", opacity: 0.85, lineHeight: 1.55 }}>
            They get three days to grab their seat back before anyone else can. Then the waitlist. Then everyone.
          </div>
        </InkCard>
      </div>

      <Card padding={28} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <div>
          <Overline color="var(--ember-700)">Only this changes</Overline>
          <h2 style={{ margin: "6px 0 0", fontFamily: "var(--font-display)", fontSize: "var(--text-xl)", fontWeight: 800, letterSpacing: "var(--tracking-tight)" }}>
            Season 2 dates
          </h2>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          {fieldViews(REUP_FIELDS, false).map((f) => (
            <FieldCell key={f.id} f={f} />
          ))}
        </div>

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", borderTop: "1px solid var(--border-subtle)", paddingTop: 20 }}>
          <Button variant="ghost" onClick={() => onNavigate("trybs")}>
            Not yet
          </Button>
          <Button variant="primary" onClick={publish}>
            Publish season 2
          </Button>
        </div>
      </Card>
    </div>
  );
}
